/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum BlackjackResult {
    BUST = 'bust',
    WON = 'won',
    TIE = 'tie',
    LOST = 'lost',
}
